export default [
  {
    name: 'TemplatesList',
    path: '/templates',
    component: () => import('pages/templates/TemplatesList.vue')
  },
  {
    name: 'TemplatesCreate',
    path: '/templates/new',
    component: () => import('pages/templates/TemplatesForm.vue')
  },
  {
    name: 'TemplatesEdit',
    path: '/templates/:id/edit',
    component: () => import('pages/templates/TemplatesForm.vue')
  },
  {
    name: 'TemplatesAttachmentsCreate',
    path: '/templates-attachments/new',
    component: () => import('pages/templates/attachments-form/TemplatesAttachmentsForm.vue')
  },
  {
    name: 'TemplatesAttachmentsEdit',
    path: '/templates-attachments/:id/edit',
    component: () => import('pages/templates/attachments-form/TemplatesAttachmentsForm.vue')
  }
]
